module.exports = __webpack_public_path__ + "static/media/tile-6.ca350979.jpg";